import React from "react";
import TokenBox from "../../TokenBox";

const Screen05 = () => {
    return <TokenBox />;
};

export default Screen05;
